import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { baseColors, designTokens } from "theme";

export const styles = (theme: Theme) => ({
	link: {
		color: baseColors.teal,
		textDecoration: 'none',
		'&:hover': { textDecoration: 'underline' },
	},
	actionBar: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	tableHeaderCell: {
		color: baseColors.gray,
		fontSize: 13,
		background: designTokens.colors.tableHeaderSurface,
	},
	// MAX-3878 grouped display
	controlRow: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	totalCount: {
		fontWeight: 500,
	},
	controlActions: {
		display: 'flex',
		alignItems: 'center',
		gap: 12,
	},
	accordionHeader: {
		display: 'flex',
		alignItems: 'center',
		width: '100%',
	},
	chevron: {
		display: 'flex',
		alignItems: 'center',
		marginRight: 8,
		color: baseColors.gray,
		transition: 'transform 150ms ease',
	},
	chevronOpen: {
		transform: 'rotate(180deg)',
	},
	categoryName: {
		fontWeight: 600,
	},
	headerSpacer: {
		flexGrow: 1,
	},
	categoryCount: {
		marginRight: 8,
		whiteSpace: 'nowrap',
	},
	kebab: {
		color: baseColors.gray,
	},
	// Destructive menu item (Delete Category) — red per Figma. Muted when disabled (last category).
	destructiveMenuItem: {
		color: baseColors.brightRed,
		'&.Mui-disabled': {
			color: baseColors.gray,
		},
	},
	emptyCategory: {
		padding: '8px 0',
	},
	// MAX-4201 — "Market Needed" line under a blocked campaign's name (amber, matching the activation dialogs).
	marketNeeded: {
		display: 'flex',
		alignItems: 'center',
		gap: 4,
		marginTop: 2,
		color: baseColors.gray,
	},
	marketNeededIcon: {
		color: '#f59e0b',
		fontSize: 16,
	},
	// MAX-3871 — ID column: value + inline copy affordance.
	idCell: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: 4,
	},
	copyIconButton: {
		color: baseColors.gray,
		padding: 6,
		// Nudge down — the icon otherwise sits visually high against the ID text's baseline.
		position: 'relative',
		top: 1,
	},
} satisfies Record<string, CSSObject>);
